import { LocationModel } from '../../../../types/Location';
import { DBWriterLoggerFunction } from '../../../../types/logger';

export const prepareDeleteLocation = ({
    locationElement,
}: {
    locationElement: LocationModel;
}) => locationElement.prepareMarkAsDeleted();

export const logDeleteLocationAction = ({
    location,
    logDBAction,
    tableName,
}: {
    location: LocationModel;
    logDBAction: DBWriterLoggerFunction;
    tableName: string;
}) => {
    logDBAction({
        message: 'Delete location',
        modelName: tableName,
        payload: location,
    });
};
